'use client';

import type { FC } from 'react';

import { cn } from '@/lib/utils';

import { ImageLink, type ImageLinkProps } from '@/components/atoms/ImageLink';
import { Title } from '@/components/atoms/Typography/Title';
import { ButtonsFactory } from '@/components/molecules/ButtonsFactory';
import type { ButtonsFactoryProps } from '@/components/molecules/ButtonsFactory/ButtonsFactory';
import type { ContentTextProps } from '@/components/molecules/ContentText';
import { ContentText } from '@/components/molecules/ContentText';
import {
    IconsLinksList,
    type IconsLinksListProps,
} from '@/components/molecules/IconsLinksList';

export interface BasicContentProps {
    logoConfig?: {
        position: 'top' | 'bottom';
        props: ImageLinkProps;
        text?: string;
    };
    contentTextConfig: ContentTextProps;
    buttonsConfig?: ButtonsFactoryProps;
    iconsLinksConfig?: IconsLinksListProps;
}

const BasicContent: FC<BasicContentProps> = ({
    logoConfig,
    contentTextConfig,
    buttonsConfig,
    iconsLinksConfig,
}) => (
    <div className="max-w-[22rem] lg:max-w-[556px]">
        {!!logoConfig && logoConfig.position === 'top' && (
            <ImageLink
                {...logoConfig.props}
                className="mb-4 flex justify-center md:justify-start"
            />
        )}

        <ContentText
            {...contentTextConfig}
            className={cn(
                'text-center md:text-left',
                contentTextConfig.className,
            )}
        />

        {!!buttonsConfig && (
            <ButtonsFactory
                className="mt-8 w-auto flex-nowrap md:mt-10"
                {...buttonsConfig}
            />
        )}

        {!!iconsLinksConfig && (
            <IconsLinksList
                variant="horizontalLeft"
                className="pt-10 md:justify-start"
                {...iconsLinksConfig}
            />
        )}

        {!!logoConfig && logoConfig.position === 'bottom' && (
            <>
                <Title className="mb-4 mt-10 text-center text-sm text-typo-secondary md:text-left md:text-md">
                    {logoConfig.text}
                </Title>

                <ImageLink
                    {...logoConfig.props}
                    className="mx-auto my-0 md:mx-0"
                />
            </>
        )}
    </div>
);

export default BasicContent;
